module.exports = "/_next/static/images/OgHome-470ccd9554a990c639ff23e47ef287e6.png";